import React, { useState } from 'react';
import {
  REPORT_REASONS,
  REPORT_CATEGORIES,
  SKIP_CATEGORIES,
  SKIP_REASONS,
  SKIP_BID_CATEGORIES,
  SKIP_BID_REASONS,
  INSTRUCTION_TASK_SKIP_CATEGORIES,
  BAD_PRELABEL_TASK_SKIP_CATEGORIES,
  OSTRICH_MATH_SKIP_CATEGORIES,
  NOT_EQUIPPED_SKIP_CATEGORIES,
  NOT_EQUIPPED_SKIP_REASONS,
} from '@scale/frontend-lib/constants';
import { Button } from 'design-system/Button';
import SkipOrReportTaskModal from './SkipOrReportTaskModal';
import { Bid } from '@scale/shared/types/pricing';

const DEFAULT_HEADER_TEXT = 'Skip this task';
const DEFAULT_BODY_TEXT =
  'You always have the option to skip a task. Please help us understand why so that we can make tasking better for you.';
const DEFAULT_CONFIRM_TEXT = 'Skip Task';
const DEFAULT_PLACEHOLDER_TEXT = "I'm skipping this task because...";

interface SkipTaskProps {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  handleSkip: (reason: any, explanation: string) => void;
  enableOtherReason?: boolean;
  buttonText?: string;
  style?: React.CSSProperties;
  confirmButtonText?: string;
  skipBodyText?: string;
  skipHeaderText?: string;
  explanationPlaceholder?: string;
  reportEnabled?: boolean;
  bid?: Bid; // Only supported by ImageAnnotation atm
  disabled?: boolean;
  isInstructionTask?: boolean;
  taskId?: string;
  enableBadPrelabelSkip?: boolean;
  enableOstrichMathSkip?: boolean;
  enableNotEquippedSkip?: boolean;
  avoidButtonRendering?: boolean;
}

export default function SkipTask(props: SkipTaskProps) {
  const [isModalOpenState, setIsModalOpenState] = useState(false);

  const isModalOpen = 'open' in props ? props.open! : isModalOpenState;

  const setIsModalOpen = (open: boolean) => {
    if (props.onOpenChange) {
      props.onOpenChange(open);
    } else {
      setIsModalOpenState(open);
    }
  };

  return (
    <div>
      {!props.avoidButtonRendering && (
        <Button
          key="skipTask"
          htmlType="button"
          style={props.style}
          onClick={() => setIsModalOpen(true)}
          disabled={props.disabled}
        >
          {props.buttonText || 'Skip'}
        </Button>
      )}

      <SkipOrReportTaskModal
        taskId={props.taskId}
        handleSubmit={props.handleSkip}
        isModalOpen={isModalOpen}
        onCloseModal={() => setIsModalOpen(false)}
        reasons={
          !props.enableOstrichMathSkip
            ? {
                ...SKIP_REASONS,
                ...(props.reportEnabled ? REPORT_REASONS : {}),
                ...(props.bid ? SKIP_BID_REASONS : {}),
                ...(props.enableNotEquippedSkip ? NOT_EQUIPPED_SKIP_REASONS : {}),
              }
            : {}
        }
        categories={
          props.enableOstrichMathSkip
            ? { ...OSTRICH_MATH_SKIP_CATEGORIES, ...REPORT_CATEGORIES }
            : {
                ...(props.enableBadPrelabelSkip ? BAD_PRELABEL_TASK_SKIP_CATEGORIES : {}),
                ...SKIP_CATEGORIES,
                ...(props.reportEnabled ? REPORT_CATEGORIES : {}),
                ...(props.bid ? SKIP_BID_CATEGORIES : {}),
                ...(props.isInstructionTask ? INSTRUCTION_TASK_SKIP_CATEGORIES : {}),
                ...(props.enableNotEquippedSkip ? NOT_EQUIPPED_SKIP_CATEGORIES : {}),
              }
        }
        headerText={props.skipHeaderText || DEFAULT_HEADER_TEXT}
        bodyText={props.skipBodyText || DEFAULT_BODY_TEXT}
        confirmButtonText={props.confirmButtonText || DEFAULT_CONFIRM_TEXT}
        explanationPlaceholder={props.explanationPlaceholder || DEFAULT_PLACEHOLDER_TEXT}
        requireExplanation={props.enableOstrichMathSkip}
      />
    </div>
  );
}
